import React, { useEffect, useState } from 'react';
import { Sidebar } from '../../../_shared/Sidebar';
import {
	getShortlist,
	OCEAN_OPEN_SHORTLIST_EVENT,
	removeFromShortlist,
	SHORTLIST_CHANGE_EVENT,
	ShortlistItem,
	} from '../../../_shared/shortlist';

// Single sidebar instance mounted once per page (see index.tsx) -- every
// ocean/shortlist trigger (e.g. one per nav menu) opens this same instance
// via the OCEAN_OPEN_SHORTLIST_EVENT remote-open pattern, same as
// booking-filters' OCEAN_OPEN_FILTERS_EVENT.
export const ShortlistSidebar = () =>
	{
	const [isOpen, setIsOpen] = useState(false);
	const [items, setItems] = useState<ShortlistItem[]>([]);

	useEffect(() =>
		{
		setItems(getShortlist());

		const handleOpen = () => setIsOpen(true);
		const handleChange = (event: Event) => setItems((event as CustomEvent<ShortlistItem[]>).detail || []);

		document.addEventListener(OCEAN_OPEN_SHORTLIST_EVENT, handleOpen);
		window.addEventListener(SHORTLIST_CHANGE_EVENT, handleChange);
		return () =>
			{
			document.removeEventListener(OCEAN_OPEN_SHORTLIST_EVENT, handleOpen);
			window.removeEventListener(SHORTLIST_CHANGE_EVENT, handleChange);
			};
		}, []);

	const searchResultsUrl = window.oceanSearchData?.searchResultsPageUrl || '/';

	return (
		<Sidebar isOpen={isOpen} onClose={() => setIsOpen(false)} title="Shortlist">
			{items.length === 0 ? (
				<p className="shortlist__empty">Your shortlist is empty.</p>
			) : (
				<ul className="shortlist__list">
					{items.map((item) => (
						<li key={item.id} className="shortlist__item">
							<a href={item.permalink} className="shortlist__thumb">
								{item.thumbnail && <img src={item.thumbnail} alt="" />}
							</a>
							<a href={item.permalink} className="shortlist__title">{item.title}</a>
							<button
								type="button"
								className="shortlist__remove"
								onClick={() => removeFromShortlist(item.id)}
							>
								Remove
							</button>
						</li>
					))}
				</ul>
			)}
			<a href={searchResultsUrl} className="shortlist__search-more">
				Search for more
			</a>
		</Sidebar>
		);
	};
